exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row[data-v-7d959551]{display:flex}.row.align-left[data-v-7d959551]{justify-content:flex-start}.row.align-center[data-v-7d959551]{justify-content:center}.row.align-right[data-v-7d959551]{justify-content:flex-end}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d959551","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/grid/row/bf-row.vue
// module id = 48
// module chunks = 0